/**
 * Salle vidéo native d'une RÉUNION LIBRE (Phase D, migration 0259) — l'hôte a
 * été admis d'office à son propre roster par `create_visio_meeting`
 * (`_app.tutor.rendez-vous.reunion.tsx`) qui renvoie déjà `room_id` :
 * contrairement à `_app.rendez-vous.$reservationId.room.tsx` (créneau réservé,
 * `get_or_create_visio_room`), AUCUN appel RPC n'est nécessaire ici pour
 * résoudre la salle — `roomId` est déjà connu, on monte `RoomPage`
 * directement avec la session déjà live de l'app.
 */
import { useParams, useNavigate } from '@tanstack/react-router';
import type { SupabaseClient } from '@supabase/supabase-js';
import { RoomPage } from '@jeraisonne/visio';
import { supabase, supabaseUrl } from '@/lib/supabase';
import { useAuth } from '@/lib/auth';
import { deriveVisioRole } from '@/lib/visio/derive-role';
import { buildVisioInviteUrl } from '@/lib/visio/tutor-url';

const db = supabase as unknown as SupabaseClient;

export function FreeMeetingRoomPage() {
  const { roomId } = useParams({ strict: false }) as { roomId: string };
  const { user, profile, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  function exitToRendezVous() {
    void navigate({ to: '/tutor/rendez-vous' });
  }

  if (authLoading || !user) {
    return (
      <div className="flex min-h-dvh items-center justify-center px-4 py-6 sm:py-8">
        <div className="border-primary-400 h-8 w-8 animate-spin rounded-full border-2 border-t-transparent" />
      </div>
    );
  }

  return (
    <RoomPage
      roomId={roomId}
      me={{
        userId: user.id,
        role: deriveVisioRole(profile?.role),
        displayName: profile?.display_name ?? '',
      }}
      db={db}
      supabaseUrl={supabaseUrl}
      onExit={exitToRendezVous}
      exitLabel="Retour aux rendez-vous"
      buildInviteUrl={buildVisioInviteUrl}
    />
  );
}
